import { useState, useCallback } from 'react'

export interface UseTagSelectionReturn {
  selectedTags: Set<string>
  toggleTag: (tagName: string) => void
  clearSelection: () => void
  selectMultiple: (tagNames: string[]) => void
  isSelected: (tagName: string) => boolean
  selectionCount: number
  selectedTagsArray: string[]
}

export function useTagSelection(initialSelection: string[] = []): UseTagSelectionReturn {
  const [selectedTags, setSelectedTags] = useState<Set<string>>(new Set(initialSelection))

  const toggleTag = useCallback((tagName: string) => {
    setSelectedTags((prev) => {
      const newSelected = new Set(prev)
      if (newSelected.has(tagName)) {
        newSelected.delete(tagName)
      } else {
        newSelected.add(tagName)
      }
      return newSelected
    })
  }, [])

  const clearSelection = useCallback(() => {
    setSelectedTags(new Set())
  }, [])

  const selectMultiple = useCallback((tagNames: string[]) => {
    setSelectedTags(new Set(tagNames))
  }, [])

  const isSelected = useCallback(
    (tagName: string) => {
      return selectedTags.has(tagName)
    },
    [selectedTags]
  )

  const selectionCount = selectedTags.size
  const selectedTagsArray = Array.from(selectedTags)

  return {
    selectedTags,
    toggleTag,
    clearSelection,
    selectMultiple,
    isSelected,
    selectionCount,
    selectedTagsArray,
  }
}
